import { getActiveLocation } from "features/location/selectors/getLocationLocale";
import { createSelector } from "reselect";

export const getIsMigratedLocation = createSelector(
    getActiveLocation,
    (activeLocation) => !!activeLocation?.manageMigrationUrl && !!activeLocation?.migrationSlug
)